require("./shop/checkout.js");
require("./shop/product.js");
require("./shop/productlist.js");
require("./shop/storage.js");
require("./shop/register.js");